import { render, staticRenderFns } from "./centerTable.vue?vue&type=template&id=8b1bac82&scoped=true&"
import script from "./centerTable.vue?vue&type=script&lang=js&"
export * from "./centerTable.vue?vue&type=script&lang=js&"
import style0 from "./centerTable.vue?vue&type=style&index=0&id=8b1bac82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1bac82",
  null
  
)

export default component.exports